import { gql } from '@apollo/client';
import React from 'react';
import { Constrain, Stack } from '@moda/om';
import {
  ProductBreadcrumbs,
  PRODUCT_BREADCRUMBS_FRAGMENT
} from '../../components/ProductBreadcrumbs';
import { ProductDetails, PRODUCT_DETAILS_FRAGMENT } from '../../components/ProductDetails';
import {
  ProductMediaGallery,
  PRODUCT_MEDIA_GALLERY_FRAGMENT
} from '../../components/ProductMediaGallery';
import { ProductShopLinks, PRODUCT_SHOP_LINKS_FRAGMENT } from '../../components/ProductShopLinks';
import { ProductRecommendations } from '../../components/ProductRecommendations';
import { SoldOutProductRecommendations } from '../../components/SoldOutProductRecommendations';
import { ProductDetailPageFragment } from '../../generated/types/ProductDetailPageFragment';
import {
  SchemaOrgProductDetailPage,
  SCHEMA_ORG_PRODUCT_DETAIL_PAGE_FRAGMENT,
  SchemaOrgProductBreadcrumbs,
  SCHEMA_ORG_PRODUCT_BREADCRUMBS_FRAGMENT
} from '../../components/SchemaOrg';
import { ProductDetailPageMeta, PRODUCT_DETAIL_PAGE_META_FRAGMENT } from './ProductDetailPageMeta';
import './ProductDetailPage.scss';

export const PRODUCT_DETAIL_PAGE_FRAGMENT = gql`
  fragment ProductDetailPageFragment on Variant {
    id
    canSell: can_sell
    masterVariant: master_variants_data {
      id
    }
    otherVariants: other_variants_data {
      id
    }
    ...ProductDetailPageMetaFragment
    ...ProductBreadcrumbsFragment
    ...ProductDetailsFragment
    ...ProductMediaGalleryFragment
    ...ProductShopLinksFragment
    ...SchemaOrgProductDetailPageFragment
    ...SchemaOrgProductBreadcrumbsFragment
  }
  ${PRODUCT_DETAIL_PAGE_META_FRAGMENT}
  ${PRODUCT_BREADCRUMBS_FRAGMENT}
  ${PRODUCT_DETAILS_FRAGMENT}
  ${PRODUCT_MEDIA_GALLERY_FRAGMENT}
  ${PRODUCT_SHOP_LINKS_FRAGMENT}
  ${SCHEMA_ORG_PRODUCT_DETAIL_PAGE_FRAGMENT},
  ${SCHEMA_ORG_PRODUCT_BREADCRUMBS_FRAGMENT}
`;

interface Props {
  variant: ProductDetailPageFragment;
}

export const ProductDetailPage: React.FC<Props> = ({ variant }) => {
  return (
    <>
      <ProductDetailPageMeta variant={variant} />
      <SchemaOrgProductDetailPage variant={variant} />
      <SchemaOrgProductBreadcrumbs variant={variant} />

      {!variant.canSell && <SoldOutProductRecommendations variantId={variant.id} />}

      <Constrain>
        <Stack space={6} className="ProductDetailPage" data-variant-id={variant.id}>
          <ProductBreadcrumbs variant={variant} />

          <div className="ProductDetailPage__fold">
            <div
              className="ProductDetailPage__media"
              data-variant-pk={variant.id}
              data-product-id={variant.productId}
            >
              <ProductMediaGallery variant={variant} />
            </div>

            <div className="ProductDetailPage__metadata">
              <ProductDetails variant={variant} />
            </div>
          </div>

          <ProductShopLinks variant={variant} />

          <ProductRecommendations variantId={variant.id} />
        </Stack>
      </Constrain>
    </>
  );
};
